import { css } from '@mui/material/styles';
export const typographyComponentOverrides = {
    MuiTypography: {
        defaultProps: {
            variant: 'body1'
        },
        variants: [
            {
                props: {
                    variant: 'label'
                },
                style: ({ theme }) => css `
                    color: ${theme.tokens.FuelColorGray900} !important;
                    font-weight: ${theme.tokens.FuelFontWeightSemibold} !important;
                `
            }
        ],
        styleOverrides: {
            root: ({ theme }) => css `
                &[data-fuel-size='xs'] {
                    font-size: ${theme.tokens.FuelFontSizeXs};
                    line-height: ${theme.tokens.FuelLineHeightXs};
                }

                &[data-fuel-size='sm'], &[data-fuel-size='small'] {
                    font-size: ${theme.tokens.FuelFontSizeSm};
                    line-height: ${theme.tokens.FuelLineHeightSm};
                }

                &[data-fuel-size='md'], &[data-fuel-size='medium'] {
                    font-size: ${theme.tokens.FuelFontSizeMd};
                    line-height: ${theme.tokens.FuelLineHeightMd};
                }

                &[data-fuel-size='lg'], &[data-fuel-size='large'] {
                    font-size: ${theme.tokens.FuelFontSizeLg};
                    line-height: ${theme.tokens.FuelLineHeightLg};
                }

                &[data-fuel-size='xl'] {
                    font-size: ${theme.tokens.FuelFontSizeXl};
                    line-height: ${theme.tokens.FuelLineHeightXl};
                }

                &[data-fuel-size='2xl'] {
                    font-size: ${theme.tokens.FuelFontSize2xl};
                    line-height: ${theme.tokens.FuelLineHeight2xl};
                }

                &[data-fuel-size='3xl'] {
                    font-size: ${theme.tokens.FuelFontSize3xl};
                    line-height: ${theme.tokens.FuelLineHeight3xl};
                }

                &[data-fuel-size='4xl'] {
                    font-size: ${theme.tokens.FuelFontSize4xl};
                    line-height: ${theme.tokens.FuelLineHeight4xl};
                }

                &[data-fuel-size='5xl'] {
                    font-size: ${theme.tokens.FuelFontSize5xl};
                    line-height: ${theme.tokens.FuelLineHeight5xl};
                }

                &[data-fuel-size='6xl'] {
                    font-size: ${theme.tokens.FuelFontSize6xl};
                    line-height: ${theme.tokens.FuelLineHeight6xl};
                }
            `
        }
    }
};
